
<ul *ngIf="menu.length">
    <li *ngFor="let item of menu">
            <a *ngIf="item.external" [href]="item.link" [title]="item.label" target="_blank">{{item.label}}</a>
            <a *ngIf="!item.external" [href]="item.link" [title]="item.label" target="_self">{{item.label}}</a>
            <ng-container *ngIf="item.subtree.length">
                <app-subtree-sitemap [menu]="item.subtree"></app-subtree-sitemap>
            </ng-container>
    </li>
</ul>